module.exports = __webpack_public_path__ + "img/fournisseursVueGeneral.602dc2f4.png";